export default [

  {
    path: '*',
    meta: {
      public: true
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true
    },
    name: 'NotFound',
    component: () => import(`@/views/error/NotFound.vue`)
  },
  {
    path: '/403',
    meta: {
      public: true
    },
    name: 'AccessDenied',
    component: () => import(`@/views/error/Deny.vue`)
  },
  {
    path: '/500',
    meta: {
      public: true
    },
    name: 'ServerError',
    component: () => import(`@/views/error/Error.vue`)
  },
  {
    path: '/login',
    meta: {
      public: true
    },
    name: 'Login',
    component: () => import(`@/views/Login.vue`)
  },
  {
    path: '/',
    meta: { },
    name: 'Root',
    redirect: {
      name: 'Home'
    }
  },
  {
    path: '/profile',
    meta: {},
    name: 'Profile',
    component: () => import('@/views/sys/Profile.vue')
  },
  {
    path: '/settings',
    meta: {},
    name: 'Settings',
    component: () => import('@/views/sys/Settings.vue')
  },
  {
    path: '/home',
    meta: { breadcrumb: true },
    name: 'Home',
    component: () => import(`@/views/Home.vue`)
  },
  {
    path: '/producemng',
    meta: {
      breadcrumb: true,
      access: ['admin', 'producemng']
    },
    name: 'ProduceMng',
    component: () => import(`@/views/produce/ProduceMng.vue`)
  },
  {
    path: '/cagemng',
    meta: {
      breadcrumb: true,
      access: ['admin', 'cage']
    },
    name: 'cage/CageMng',
    component: () => import(`@/views/cage/CageMng.vue`)
  },
  {
    path: '/cagehis',
    meta: {
      breadcrumb: true,
      access: ['admin', 'cage']
    },
    name: 'cage/CageHis',
    component: () => import(`@/views/cage/CageHis.vue`)
  },
  {
    path: '/stockoutmng',
    meta: {
      breadcrumb: true,
      access: ['admin', 'stockout']
    },
    name: 'StockOutMng',
    component: () => import(`@/views/StockOut/StockOutMng.vue`)
  },
  {
    path: '/usermng',
    meta: {
      breadcrumb: true,
      access: ['admin']
    },
    name: 'UserMng',
    component: () => import(`@/views/sys/UserMng.vue`)
  },
  {
    path: '/customermng',
    meta: {
      breadcrumb: true,
      access: ['admin', 'customer']
    },
    name: 'CustomerMng',
    component: () => import(`@/views/sys/CustomerMng.vue`)
  },
  {
    path: '/formulamng',
    meta: {
      breadcrumb: true,
      access: ['admin', 'formula']
    },
    name: 'FormulaMng',
    component: () => import(`@/views/sys/FormulaMng.vue`)
  }
]
